// biome-ignore lint/style/useNodejsImportProtocol: <explanation>
import querystring from 'querystring';

export const getMainSubDirectory = (pathname: string) => {
  return `/${pathname.split('/')[1]}`;
};

export const parseQuerystring = (query: string) => {
  return querystring.parse(query.substring(1));
};
